import React from "react";
import moment from "moment";
import axios from "axios";
import { css } from "aphrodite";
import styles from "./style";
import { Offcanvas, Col, Row } from "react-bootstrap";
import TimelineStyle from "./TimelineStyle";
import PopupContent from "./PopupContent";
import DiaryDetailsContent from "./DiaryDetailsContent";

class DiaryDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupArr: [],
      openDetails: false,
      eventType: null,
      eventObj: null,
      imgUrl: [],
    };
  }

  componentDidMount() {
    this.setState({
      popupArr: this.generateArray(),
    });
  }

  //date, detailsObjdate
  showDetailsHandle = (eventType, eventObj) => {
    if (eventType !== "weightlogs" && eventType !== "heightlogs") {
      {
        this.setState({
          openDetails: true,
          eventType,
          eventObj,
          imgUrl: [],
        });
      }
    } else if (
      (eventType === "weightlogs" || eventType === "heightlogs") &&
      this.state.openDetails
    ) {
      this.setState({
        openDetails: false,
        eventType: null,
        eventObj: null,
      });
    }
  };

  //   fetchImageArr = (eventObj, eventType) => {
  //     let arr = eventObj.img.split(",");
  //     arr.map((obj, index) => {
  //       this.fetchImages(obj, eventType, eventObj);
  //     });
  //   };

  //   fetchImages = (mediaId, eventType, eventObj) => {
  //     this.setState({ loading: true, openDetails: true, imgUrl: [] });
  //     let tempArr = {};
  //     let params = {
  //       mediaId: mediaId,
  //       fileName: null,
  //     };

  //     axios({
  //       method: "post",
  //       url: `/management/api/device/media/portal`,
  //       responseType: "blob",
  //       data: params,
  //     })
  //       .then((response) => {
  //         var reader = new FileReader();
  //         reader.readAsDataURL(response.data);
  //         reader.onloadend = () => {
  //           var base64data = reader.result;
  //           //let imgUrl = base64data;
  //           tempArr["img"] = base64data;
  //           let origState = { ...this.state };
  //           origState["imgUrl"].push(tempArr);
  //           this.setState({
  //             ...origState,
  //             loading: false,
  //             eventType,
  //             eventObj,
  //           });
  //         };
  //       })
  //       .catch((err) => {
  //         this.setState({ loading: false, error: err.message });
  //       });
  //   };

  generateArray = () => {
    let popupArr = [];
    let generalArr = [];

    Object.keys(this.props.dataObj).forEach((rT) => {
      this.props.dataObj[rT].forEach((rowTypeObj) => {
        //console.log("timestamp...", moment(rowTypeObj.timestamp));
        if (
          moment(rowTypeObj.timestamp)
            .startOf("day")
            .isSame(moment(this.props.date * 1000).startOf("day")) &&
          rowTypeObj.reported
        ) {
          generalArr.push(...rowTypeObj.data);
        }
      });
    });

    let sortedArr = generalArr.sort((a, b) => {
      if (moment(a.timestamp).isBefore(moment(b.timestamp))) return 1;
      if (moment(a.timestamp).isAfter(moment(b.timestamp))) return -1;
      return 0;
    });

    sortedArr.forEach((eventObj, index) => {
      let date = eventObj.timestamp;
      if (
        moment(eventObj.timestamp)
          .startOf("day")
          .isSame(moment(this.props.date * 1000).startOf("day"))
      ) {
        popupArr.push(
          <div
            key={`${eventObj.eventType} - ${index}`}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              margin: "2em 0em",
            }}
          >
            <div
              className={css([
                TimelineStyle.container,
                TimelineStyle[`container${eventObj.eventType}`],
              ])}
            >
              {" "}
            </div>
            <div style={{ boxShadow: "8px 8px #ccc" }}>
              <PopupContent
                data={[eventObj]}
                date={date}
                type={eventObj.eventType}
                //isDiaryDetails={true}
                showDetails={() =>
                  this.showDetailsHandle(eventObj.eventType, eventObj)
                }
              />
            </div>
          </div>
        );
      }
    });
    return popupArr;
  };

  render() {
    return (
      <Offcanvas
        show={this.props.openCanvas}
        onHide={this.props.close}
        backdrop="static"
        placement="end"
        className={css(this.state.openDetails ? styles.divFilterExtended : "")}
        style={{ top: "27%" }}
      >
        <Offcanvas.Header
          style={{ backgroundColor: "#4E4E4E", color: "white", height: "7%" }}
          closeVariant="white"
          closeButton
        >
          <Offcanvas.Title style={{ fontSize: "14px" }}>
            {moment.unix(this.props.date).format("MMM DD, YYYY")}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className={css(TimelineStyle.timeline)}>
          <Row style={{ margin: "0px", height: "100%" }}>
            <Col
              style={{
                padding: "0px",
                position: "absolute",
                overflowY: "scroll",
                width: this.state.openDetails ? "50%" : "100%",
                top: "40px",
                bottom: "0px",
                overflowX: "hidden",
                left: 0,
              }}
            >
              <div>{this.state.popupArr}</div>
            </Col>
            {this.state.openDetails ? (
              <Col
                /*computer={4}*/
                className={css([TimelineStyle.timelineDetails])}
                style={{
                  padding: "20px",
                  position: "absolute",
                  overflowY: "scroll",
                  width: "50%",
                  top: "40px",
                  bottom: "0px",
                  overflowX: "hidden",
                  right: 0,
                }}
              >
                <DiaryDetailsContent
                  eventType={this.state.eventType}
                  data={this.state.eventObj}
                  imgUrl={this.state.imgUrl}
                />
              </Col>
            ) : null}
          </Row>
        </Offcanvas.Body>
      </Offcanvas>
    );
  }
}

export default DiaryDetails;
